import { Tabs } from '@pankod/refine-antd'
import { IResourceComponentsProps, useTranslate } from '@pankod/refine-core'
import { Order, Supplement } from 'interfaces'
import { useState } from 'react'
import { CANCELLED_STATUS, DECREASE_RETURN_STATUS, INTERNAL_SPENDING_RETURN_STATUS, NO_STOCK_STATUS, ORDER_STATUS_ID_REQUESTED, PARCIAL_RETURN_STATUS, PENALIZATION_STATUS, RETURN_STATUS, formatDateTime } from 'utility'
import { capitalizeFirstLetter } from 'utility/capitalizeFirstLetter'
import '../../custom.css'
import { RequestOrdersList } from './requestOrdersList'
import { getPurchaseUrl } from './specialStores'

export type RequestOrdersListProps = {
  active?: boolean
  select: string
  dataToExport: (orders: any[]) => any
  getConditionalClassName: (record: Order) => string
  onlyPaidOrders: boolean
  statusOrder: Number | Number[] | null
  specialFilter?: string | null
}

export const RequestOrdersTable: React.FC<IResourceComponentsProps> = () => {
  const select = 'id, comments, estimated_costs_status, iva_status, iva_intra, alias, total, is_priority, syniva_price, subscribed_order, completed, created_at, estimated_delivered_date, package_number, location, cancelation_date, initial_payment, return_date, locked, locked_by, status_id, prev_status_id, sequra_disbursement_ref, status(id, name), items(id, name, url, custom_order_site, deleted), custom_marketplace_id, marketplace_id!inner(id, name, is_marketplace, original_url), shipping_method_id(id, name), supplements(supplement, volumetric, description, status(id, name))'

  const t = useTranslate()

  const [requestTab, setRequestTab] = useState(localStorage.getItem('lastRequestOrderListTab') || '1')

  const getConditionalClassName = (record: Order) => {
    if (record.cancelation_date && (record.status_id !== CANCELLED_STATUS && record.status_id !== PENALIZATION_STATUS && record.status_id !== NO_STOCK_STATUS)) {
      return 'cancelled-order'
    }
    if (record.return_date && record.status_id !== RETURN_STATUS && record.status_id !== PARCIAL_RETURN_STATUS && record.status_id !== DECREASE_RETURN_STATUS && record.status_id !== INTERNAL_SPENDING_RETURN_STATUS) {
      return 'return-order'
    }
    return ''
  }

  const handleClick = (key: string, e: any) => {
    e.preventDefault()
    setRequestTab(key)
    localStorage.setItem('lastRequestOrderListTab', key)
    localStorage.removeItem('requestOrdersPage')
  }

  const dataToExport = (orders: any[]) => {
    return orders?.map((order: any) => {
      const marketplace = order?.marketplace_id?.id
        ? order?.marketplace_id?.name
        : (order?.items && order?.items[0]?.custom_order_site) ? order?.items[0]?.custom_order_site : (order?.marketplace_id?.name || '')

      const supplementAmount = (order.supplements && order.supplements.length > 0)
        ? order?.supplements
          .map((s: Supplement) => s.supplement || 0)
          .reduce((a: number, b: number) => a + b, 0)
        : 0

      const data = {
        [t('order.fields.id')]: order?.id || '',
        [t('order.fields.createdAt')]: formatDateTime(order?.created_at, true) || '',
        [t('order.fields.alias')]: order?.alias || '',
        [t('order.fields.package_number')]: order?.package_number || '',
        [t('order.fields.location')]: order?.location || '',
        [t('order.fields.marketplace')]: marketplace || '',
        [t('order.fields.purchaseUrl')]: getPurchaseUrl(order),
        [t('order.fields.status')]: capitalizeFirstLetter(order?.status?.name) || '',
        [t('order.fields.supplementShipment')]: supplementAmount || 0
      }

      return data
    })
  }

  // "economyReduced": "ECONOMY Y ESTÁNDAR REDUCIDO",
  // "requestedSuscription": "ECONOMY CON SUSCRIPCIÓN",
  // "amazon": "AMAZON",
  // "mktPlace": "MKT PLACE",
  // "internos": "INTERNOS",
  // "personalizados": "PERSONALIZADOS",

  return (
    <Tabs defaultActiveKey='1' activeKey={requestTab} size='middle' onTabClick={handleClick}>
      <Tabs.TabPane tab={t('order.economyReducedTab')} key='1'>
        <RequestOrdersList
          active={requestTab === '1'}
          select={select}
          dataToExport={dataToExport}
          getConditionalClassName={getConditionalClassName}
          onlyPaidOrders={true}
          statusOrder={ORDER_STATUS_ID_REQUESTED}
          specialFilter={t('economyReduced')}
        />
      </Tabs.TabPane>
      <Tabs.TabPane tab={t('order.requestedOrdersSuscription')} key='2'>
        <RequestOrdersList
          active={requestTab === '2'}
          select={select}
          dataToExport={dataToExport}
          getConditionalClassName={getConditionalClassName}
          onlyPaidOrders={false}
          statusOrder={ORDER_STATUS_ID_REQUESTED}
          specialFilter={'requestedSuscription'}
        />
      </Tabs.TabPane>
      <Tabs.TabPane tab={t('order.amazonTab')} key='3'>
        <RequestOrdersList
          active={requestTab === '3'}
          select={select}
          dataToExport={dataToExport}
          getConditionalClassName={getConditionalClassName}
          onlyPaidOrders={false}
          statusOrder={ORDER_STATUS_ID_REQUESTED}
          specialFilter={t('amazon')}
        />
      </Tabs.TabPane>
      <Tabs.TabPane tab={t('order.mktPlaceTab')} key='4'>
        <RequestOrdersList
          active={requestTab === '4'}
          select={select}
          dataToExport={dataToExport}
          getConditionalClassName={getConditionalClassName}
          onlyPaidOrders={false}
          statusOrder={ORDER_STATUS_ID_REQUESTED}
          specialFilter={t('mktPlace')}
        />
      </Tabs.TabPane>
      <Tabs.TabPane tab={t('order.specialsTab')} key='5'>
        <RequestOrdersList
          active={requestTab === '5'}
          select={select}
          dataToExport={dataToExport}
          getConditionalClassName={getConditionalClassName}
          onlyPaidOrders={false}
          statusOrder={ORDER_STATUS_ID_REQUESTED}
          specialFilter={'specials'}
        />
      </Tabs.TabPane>
      <Tabs.TabPane tab={t('order.internTab')} key='6'>
        <RequestOrdersList
          active={requestTab === '6'}
          select={select}
          dataToExport={dataToExport}
          getConditionalClassName={getConditionalClassName}
          onlyPaidOrders={false}
          statusOrder={ORDER_STATUS_ID_REQUESTED}
          specialFilter={t('intern')}
        />
      </Tabs.TabPane>
      <Tabs.TabPane tab={t('order.customTab')} key='7'>
        <RequestOrdersList
          active={requestTab === '7'}
          select={select}
          dataToExport={dataToExport}
          getConditionalClassName={getConditionalClassName}
          onlyPaidOrders={false}
          statusOrder={ORDER_STATUS_ID_REQUESTED}
          specialFilter={t('order.custom')}
        />
      </Tabs.TabPane>
      <Tabs.TabPane tab='REVISIÓN MANUAL' key='manualReview'>
        <RequestOrdersList active={requestTab === 'manualReview'} select={select}
          dataToExport={dataToExport} getConditionalClassName={getConditionalClassName}
          onlyPaidOrders={false} statusOrder={ORDER_STATUS_ID_REQUESTED} specialFilter='manualReview' />
      </Tabs.TabPane>
    </Tabs>
  )
}
